module.exports = __webpack_public_path__ + "static/img/drug.96595ac4.png";